import type { JournalEntryAccount } from '@vy/types';

export const ACCOUNT_LABELS: Record<JournalEntryAccount, string> = {
  AR: 'Accounts Receivable',
  Revenue: 'Revenue',
  DeferredRevenue: 'Deferred Revenue',
  UnbilledRevenue: 'Unbilled Revenue',
};

export function formatJournalEntryAccount(account: JournalEntryAccount): string {
  return ACCOUNT_LABELS[account];
}
